interface CacheData<T> {
    updatedAt: number;
    data: T | null;
}

class Cacher<T> {
    constructor(
        private cacheKey: string,
        private ttl: number = 60 * 60 * 1000,
    ) {
        this.cacheKey = cacheKey;
        this.ttl = ttl;
    }

    public getCachedData(): T | null {
        const cached = localStorage.getItem(this.cacheKey);
        if (cached) {
            try {
                const data: CacheData<T> = JSON.parse(cached);

                // Проверяем, не истек ли TTL
                const isExpired = Date.now() - data.updatedAt > this.ttl;
                if (isExpired) {
                    this.clearCache(); // Если кеш устарел, очищаем его
                    return null;
                }

                if (data.updatedAt && data.data) {
                    return data.data;
                }
            } catch (error) {
                console.error("Invalid cache data", error);
                return null;
            }
        }
        return null;
    }

    public setCache(data: T): void {
        const cacheData: CacheData<T> = {
            updatedAt: Date.now(),
            data: data,
        };

        localStorage.setItem(this.cacheKey, JSON.stringify(cacheData));
    }

    public clearCache(): void {
        localStorage.removeItem(this.cacheKey);
    }
}

export default Cacher;
